<template>
  <router-view/>
  
  <!-- WhatsApp Popup -->
  <div v-if="showWhatsAppPopup" class="fixed inset-0 bg-black/50 z-[1000000000000001] flex items-center justify-center" @click.self="showWhatsAppPopup = false">
    <div class="bg-white rounded-2xl p-6 shadow-2xl max-w-sm w-[90%] animate-popup">
      <h3 class="text-lg font-bold text-gray-800 mb-4 text-center">Choisissez votre ville</h3>
      <div class="flex flex-col gap-3">
        <a href="https://wa.me/+2290150223847" target="_blank" 
           class="flex items-center gap-3 p-4 bg-[#25D366] hover:bg-[#20bd5a] rounded-xl text-white transition-all">
          <i class="fa-brands fa-whatsapp text-2xl"></i>
          <div>
            <span class="font-semibold">Parakou</span>
            <span class="block text-sm opacity-90">+229 01 50 22 38 47</span>
          </div>
        </a>
        <a href="https://wa.me/+2290166519432" target="_blank" 
           class="flex items-center gap-3 p-4 bg-[#25D366] hover:bg-[#20bd5a] rounded-xl text-white transition-all">
          <i class="fa-brands fa-whatsapp text-2xl"></i>
          <div>
            <span class="font-semibold">Calavi</span>
            <span class="block text-sm opacity-90">+229 01 66 51 94 32</span>
          </div>
        </a>
      </div>
      <button @click="showWhatsAppPopup = false" class="mt-4 w-full py-2 text-gray-500 hover:text-gray-700 text-sm">
        Fermer
      </button>
    </div>
  </div>

  <!-- WhatsApp Button -->
  <div @click="showWhatsAppPopup = true" class="w-[50px] h-[50px] shadow-11xl flex justify-center items-center rounded-[50%] overflow-hidden cursor-pointer fixed right-[25px] bottom-[25px] bg-[#25D366] z-[1000000000000000]">
    <i class="fa-brands fa-whatsapp text-3xl font-bold text-white fa-bounce"></i>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const showWhatsAppPopup = ref(false)
</script>

<style>
.animate-popup {
  animation: popupIn 0.2s ease-out;
}

@keyframes popupIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.parent::-webkit-scrollbar {
  width: 0%;
  height: 0%;
}
.spinner {
   position: relative;
   width: 10px;
   height: 10px;
}

.spinner div {
   animation: spinner-4t3wzl 1.875s infinite backwards;
   background-color: rgb(234, 88, 12);
   border-radius: 50%;
   height: 100%;
   position: absolute;
   width: 100%;
}

.spinner div:nth-child(1) {
   animation-delay: 0.15s;
   background-color: rgba(234, 88, 12, 0.9);
}

.spinner div:nth-child(2) {
   animation-delay: 0.3s;
   background-color: rgba(234, 88, 12,0.8);
}

.spinner div:nth-child(3) {
   animation-delay: 0.45s;
   background-color: rgba(234, 88, 12,0.7);
}

.spinner div:nth-child(4) {
   animation-delay: 0.6s;
   background-color: rgba(234, 88, 12,0.6);
}

.spinner div:nth-child(5) {
   animation-delay: 0.75s;
   background-color: rgba(234, 88, 12,0.5);
}

@keyframes spinner-4t3wzl {
   0% {
      transform: rotate(0deg) translateY(-200%);
   }

   60%, 100% {
      transform: rotate(360deg) translateY(-200%);
   }
}

.spinner1 {
   position: relative;
   width: 5px;
   height: 5px;
}

.spinner1 div {
   animation: spinner-4t3wzl1 1.875s infinite backwards;
   background-color: #fff;
   border-radius: 50%;
   height: 100%;
   position: absolute;
   width: 100%;
}

.spinner1 div:nth-child(1) {
   animation-delay: 0.15s;
   background-color: rgba(255, 255, 255, 0.9);
}

.spinner1 div:nth-child(2) {
   animation-delay: 0.3s;
   background-color: rgba(255,255,255,0.8);
}

.spinner1 div:nth-child(3) {
   animation-delay: 0.45s;
   background-color: rgba(255,255,255,0.7);
}

.spinner1 div:nth-child(4) {
   animation-delay: 0.6s;
   background-color: rgba(255,255,255,0.6);
}

.spinner1 div:nth-child(5) {
   animation-delay: 0.75s;
   background-color: rgba(255,255,255,0.5);
}

@keyframes spinner-4t3wzl1 {
   0% {
      transform: rotate(0deg) translateY(-200%);
   }

   60%, 100% {
      transform: rotate(360deg) translateY(-200%);
   }
}
</style>
